const wueActionMap = {
	'auto updated': 'auto update',
	added: 'add',
	applied: 'apply',
	changed: 'change',
	clicked: 'click',
	collapsed: 'collapse',
	completed: 'complete',
	displayed: 'display',
	expanded: 'expand',
	impression: 'view',
	navigated: 'navigate',
	opened: 'open',
	received: 'receive',
	removed: 'remove',
	saved: 'save',
	selected: 'select',
	submitted: 'submit',
	swiped: 'swipe',
	updated: 'update',
	viewed: 'view'
};

const replaceValues = (inputString, map) => {
	let str;
	if (typeof inputString === 'string') {
		str = inputString
			.toLowerCase()
			.split(' ')
			.map((word) => map[word] || word)
			.join(' ');
	}
	return str;
};

const replaceUrl = (inputString) => {
	const urlPattern = /(https?:\/\/[^\s]+)/g;
	const match = inputString.match(urlPattern);
	let destinationUrl = '';

	if (match) {
		[destinationUrl] = match;
		const updatedString = inputString.replace(
			urlPattern,
			'destination url'
		);
		return { updatedString, destinationUrl };
	}

	return { updatedString: inputString, destinationUrl: '' };
};

const SPECIALS_EVENT_PERSONALIZATION = {
	'CVRE recommended vehicles': 'cvre',
	'WIS recommended vehicles': 'wis',
	'Featured vehicles': 'featured',
	'New arrival vehicles': 'new arrivals'
};

export default {
	events: {
		'ddc.form.confirmation': [
			{
				payload: ({ eventData }) => {
					// Build the base event object
					const eventPayload = {
						element: 'lead',
						action: 'submit',
						id: eventData.eventId,
						conversionType: 'form',
						conversionInstanceId: eventData.formEventId,
						formType: eventData.formType,
						nonProductionData: true,
						pixallMigrationId: eventData.eventId
					};

					// Conditionally add vehicle data if vehicleId exists
					if (eventData.vehicleId) {
						eventPayload.vehicle = {
							vin: eventData.vin || '',
							dealerStockNumber: eventData.stockNumber || '',
							exteriorColor: eventData.exteriorColor || '',
							id: eventData.vehicleId,
							type: eventData.vehicleType || '',
							listingAccountId: eventData.listingCode || ''
						};
					}

					return {
						event: eventPayload,
						user: {
							emailAddress:
								eventData.cdl?.user?.emailAddress || ''
						}
					};
				}
			}
		],
		widgetUserEvent: {
			payload: ({ eventData }) => {
				// Properties to exclude from the final payload
				const propsToFilter = [
					'formId',
					'fieldValue',
					'formEventId',
					'sourceData',
					'value',
					'widgetState',
					'gtm.uniqueEventId',
					'uuid',
					'event',
					'action',
					'result',
					'elementCTA',
					'windowId',
					'mywallet'
				];

				// Build remainingCdlData by excluding certain properties
				const remainingCdlData = Object.keys(eventData).reduce(
					(acc, key) => {
						if (!propsToFilter.includes(key)) {
							acc[key] = eventData[key];
						}
						return acc;
					},
					{}
				);

				// Map action values
				const mappedAction =
					replaceValues(eventData.action, wueActionMap) ||
					eventData.action;

				// Map result to intention
				let intention = eventData.result;
				let destinationUrl;
				if (typeof intention === 'string') {
					intention =
						replaceValues(intention, wueActionMap) || intention;
					const replacementObj = replaceUrl(intention);
					intention = replacementObj.updatedString;
					destinationUrl = replacementObj.destinationUrl;
				}

				// Handle personalization for ws-rec-vehicles widget
				let personalization = {};
				if (eventData.widgetName === 'ws-rec-vehicles') {
					personalization = {
						personalization:
							SPECIALS_EVENT_PERSONALIZATION[eventData.element] ||
							null
					};
				}

				return {
					event: {
						...(intention && { intention }),
						elementText: eventData.elementCTA,
						category: 'widgetUserEvent',
						...remainingCdlData,
						...(typeof remainingCdlData?.element !== 'string' && {
							element: ''
						}),
						action: mappedAction,
						...(destinationUrl && { destinationUrl }),
						...personalization,
						...(typeof eventData.mywallet === 'boolean' && {
							myWalletFlag: eventData.mywallet
						})
					}
				};
			}
		}
	}
};
